export default __webpack_public_path__ + "static/media/createGroup.203ef0b0.png";